export default "__VITE_ASSET__14ed78b2__"